// external
import type { Store } from 'redux';

// libraries
import { BaseMiddleware } from '@makemydeal/dr-activities-common';

// store
import type { Selectors } from './selectors';

export class MiddlewareManager extends BaseMiddleware {
    constructor(
        public selectors: Selectors,
        public baseRoute?: string,
        public analyticsAction?: (store: any, key: string, desc: string) => void
    ) {
        super(selectors, analyticsAction);
    }

    /**
     * any activity specific middleware code should be defined here;
     * application-specific middleware should be outside of the activity
     */
    protected middlewareFunction = (_store: Store<any>, _next: any, _action: any): void => {
        // no-op: middleware to be implemented by specific activity
    };
}
